import React from 'react';
import {DataGrid, GridRenderCellParams} from '@mui/x-data-grid';
import {useNavigate} from "react-router-dom";
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";

export const UserHoldingsTable: React.FC<{ holdings: any[] }> = ({ holdings }) => {

    let goTo = useNavigate();

    const columns = [
        {
            field: 'pictureUrl',
            headerName: 'Stock',
            headerClassName: 'table-header',
            width: 140,
            renderCell: (params: GridRenderCellParams) => (
                <div style={{ display: 'flex', alignItems: 'left', height: '100%' }} onClick={() => goTo('/assets/' + params.row.symbol)}>
                    <img src={params.row.pictureUrl} alt="Logo" style={{ width: 'auto', height: '50%', borderRadius: '50%', alignSelf: 'center' }} />
                    <span style={{marginLeft: 10}}>{params.row.symbol}</span>
                </div>
            )
        },
        {
            field: 'marketValue',
            headerName: 'Market Value',
            headerClassName: 'table-header',
            renderCell: (params: GridRenderCellParams) => (
                <div>
                    ${params.value}
                </div>
            ),
        },
        {
            field: 'percentOfPortfolio',
            headerName: '% Alloc',
            headerClassName: 'table-header',
            renderCell: (params: GridRenderCellParams) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {(params.value * 100).toFixed(0)}%
                </div>
            ),
        },
        {
            field: 'unrealizedProfitLoss',
            headerName: 'Profit',
            headerClassName: 'table-header',
            width: 90,
            renderCell: (params: GridRenderCellParams) => (
                <div style={{ color: (params.value < 0) ? 'red' : '#4caf50' }}>
                    ${params.value}
                </div>
            ),
        },
        {
            field: 'unrealizedProfitLossPercent',
            headerName: '% Change',
            headerClassName: 'table-header',
            width: 100,
            renderCell: (params: GridRenderCellParams) => (
                <div style={{ color: (params.value < 0) ? 'red' : '#4caf50' }}>
                    {(params.value * 100).toFixed(0)}%
                </div>
            ),
        },
    ];

    return (
        <Box sx={{height: '35rem', width: '100%' }}>
            <Typography variant="subtitle1" component="div" align="left"
                        sx={{
                            color: '#6D6D6D',
                            font: 'Roboto',
                            fontWeight: 500,
                            fontSize: '13px',
                            lineHeight: '12px',
                            letterSpacing: '0.05em',
                            paddingBottom: '.75rem',
                            paddingTop: '0.75rem',
                            paddingLeft: '0.5rem',
                        }}>
                {holdings[holdings.length-1]?.pilot} portfolio holdings
            </Typography>
            <DataGrid
                rows={holdings}
                columns={columns}
                rowHeight={40}
                hideFooter={true}
                rowCount={holdings.length}
                getRowId={(row) => row.id || Math.random().toString(36).substr(2, 9)}  // Ensure each row has a unique ID
                initialState={{
                    sorting: {
                        sortModel: [
                            { field: 'percentOfPortfolio', sort: 'desc' },
                        ],
                    },
                }}
                autoHeight={true}
            />
        </Box>
    );
};
